import React from "react";

function Contactme() {
  return (
    <div id="contact">
      <h1 className="project-heading text-center">
        <button>Contact Me</button>
      </h1>
      <div className="contact-info">
        <div>
          <a
            className="btn btn-secondary iconc"
            href="mailto:cgorale111@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fas fa-envelope "></i> Email
          </a>
        </div>
        <div className="padd"> </div>
        <div>
          <a
            className="btn btn-secondary iconc"
            href="https://www.linkedin.com/feed/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin "></i> Linkedin
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contactme;
